import { render, staticRenderFns } from "./HotelContentItem.vue?vue&type=template&id=01bdc6d6&"
import script from "./HotelContentItem.vue?vue&type=script&lang=js&"
export * from "./HotelContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports